__turbopack_context__.v({
  "benefit": "rareInfoModals-module__AYjMPW__benefit",
  "description": "rareInfoModals-module__AYjMPW__description",
  "mainDescription": "rareInfoModals-module__AYjMPW__mainDescription",
  "powerPlugsInfoDescription": "rareInfoModals-module__AYjMPW__powerPlugsInfoDescription",
  "rareInfoModal": "rareInfoModals-module__AYjMPW__rareInfoModal",
});
